import React from 'react';
import {SearchDocs} from '../../components';
import imgExtract from './images/extract.svg';
import './ErrorPage.scss';
import {triggerYaEvent} from '../../utils/yandex_counter';


interface DocNotFoundProps {
    documentId: string;
    message: string;
    description?: string;
}

export const ErrorPage: React.FC<DocNotFoundProps> = ({documentId, message, description}) => {
    return (
        <div className="error-page">
            <img src={imgExtract} alt="" className="error-page__img"/>
            <div className="error-page__title">{message}</div>
            <div className="error-page__text">{description}</div>
            <SearchDocs
                defaultValue={documentId}
                onFocus={() => triggerYaEvent('Ошибка посадочной', 'Идентификатор документа')}
                onSearch={() => triggerYaEvent('Ошибка посадочной', 'Клик по кнопке Проверить')}
            />
        </div>
    )
}
